import classNames from 'classnames';
import { Button } from 'components/atoms';
import { useMemo } from 'react';
import { PiFile, PiX } from 'react-icons/pi';
import { IChatMessageAttachment } from 'services/chat/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import './AttachmentsCard.scss';

const imageExtensions = ['.jpp', '.jpeg', '.png', '.webp'];
const audioExtensions = ['.wav', '.mp3', '.flac'];

interface IAttachmentsCardProps {
  attachment: IChatMessageAttachment;
  onRemove?: (attachment: IChatMessageAttachment) => void;
  backgroundColor?: boolean;
}

// ODTWARZANIE AUDIO

const AttachmentsCard = ({
  attachment,
  onRemove,
  backgroundColor,
}: IAttachmentsCardProps) => {
  const isImage = useMemo(
    () => imageExtensions.includes(attachment.extension),
    [attachment.extension],
  );
  const isPdf = useMemo(
    () => attachment.extension === 'pdf',
    [attachment.extension],
  );
  const className = classNames(['attachment-card', attachment.extension], {
    isImage,
    isPdf,
    backgroundColor,
  });
  return (
    <div className={className} onClick={() => window.open(attachment.path)}>
      <div className='attachment-card-preview'>
        {isImage ? <img src={attachment.path} /> : <PiFile />}
      </div>
      <div className='attachment-card-content'>
        <div className='attachment-card-header'>{attachment.fileName}</div>
        <div className='attachment-card-description'>
          <p>{attachment.extension.toUpperCase()} </p>
          <p>{attachment.sizeInMB.toFixed(1)} MB</p>
        </div>
      </div>
      {onRemove && (
        <div
          className='attachment-card-remove'
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            onRemove(attachment);
          }}>
          <Button variant={BUTTON_VARIANT.background} onlyIcon>
            <PiX />
          </Button>
        </div>
      )}
    </div>
  );
};

export default AttachmentsCard;
